var React = require('react');

function Message (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 0H0V9V12L3 9H13V0ZM11 2H2V3H11V2ZM11 4H2V5H11V4ZM6 6H11V7H6V6Z","fill":"#019FCB"}));
}

Message.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = Message;

Message.default = Message;
